export function useOptimizedImage() {
  const getOptimizedPath = (src: string | undefined, width = 1920) => {
    if (!src) return null
    const baseName = src.split('/').pop()?.split('.')[0]
    
    return {
      webp: `/optimized/${baseName}-${width}.webp`,
      // Simplified to only use WebP
      backgroundImage: `url('/optimized/${baseName}-${width}.webp')`
    }
  }

  return {
    getOptimizedPath
  }
}